"use strict";
var MenuGroup = function() {
  this.items = [];
  this.show = false;
};
MenuGroup.prototype = {
  addItem: function(item, clickFn, showFn) {
    var newItem = {
      title: item.title,
      icon: item.icon,
      click: clickFn,
      showFn: (typeof showFn == 'function') ? showFn : (function() {
        return showFn;
      }),
      show: false
    };
    newItem.show = newItem.showFn();
    this.items.push(newItem);
  },
  calcShow: function() {
    this.show = false;
    for (var i = 0; i < this.items.length; ++i) {
      this.items[i].show = this.items[i].showFn();
      if (this.items[i].show) {
        this.show = true;
      }
    }
  }
};
module.exports = MenuGroup;
